import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

// 無料参加登録
export const freeRegister = async (eventId) => {
  const res = await axios.post(`${API}/events/${eventId}/free-register`);
  return res.data;
};

// 無料参加状態確認
export const getFreeRegisterStatus = async (eventId) => {
  const res = await axios.get(`${API}/events/${eventId}/free-register/status`);
  return res.data;
};

// 投げ銭 Checkout セッション作成
export const createDonationCheckout = async (eventId, amount) => {
  const res = await axios.post(`${API}/events/${eventId}/donations/checkout`, { amount });
  return res.data;
};

// 自分の投げ銭履歴
export const getMyDonations = async (eventId) => {
  const res = await axios.get(`${API}/events/${eventId}/donations/my`);
  return res.data;
};
